import { useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth.jsx';
import Index from './pages/Index';
import Demo from './pages/Demo';
import Login from './pages/Login';
import ParentApp from './pages/App/ParentApp';
import SchoolDashboard from './pages/App/SchoolDashboard';
import Register from './pages/Register';
import { ROUTES } from './lib/constants';

// Componente de rota protegida
function ProtectedRoute({ children, role = null }) {
    const { isAuthenticated, loading, isParent, isSchool, profile } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!loading && !isAuthenticated) {
            navigate(ROUTES.LOGIN, { replace: true });
        }
    }, [loading, isAuthenticated, navigate]);

    if (loading) {
        return (
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                <div className="text-center">
                    <div className="text-6xl animate-bounce mb-4">🚗</div>
                    <p className="text-xl text-gray-600 font-medium">Carregando...</p>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return null; // Será redirecionado pelo useEffect
    }

    // [FIX]: Se está autenticado mas o perfil ainda não carregou, espera mais um pouco
    // Evita o erro 404 ou redirecionamento precoce no refresh
    if (!profile) {
        return (
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                <div className="text-center">
                    <div className="text-6xl animate-pulse mb-4">👤</div>
                    <p className="text-xl text-gray-600 font-medium">Identificando perfil...</p>
                </div>
            </div>
        );
    }

    // Verificar papel específico se solicitado
    if (role === 'parent' && !isParent) {
        return <Navigate to={ROUTES.HOME} replace />;
    }
    if (role === 'school' && !isSchool) {
        return <Navigate to={ROUTES.HOME} replace />;
    }

    return children;
}

function AppRoutes() {
    return (
        <Routes>
            {/* Rotas públicas */}
            <Route path={ROUTES.HOME} element={<Index />} />
            <Route path={ROUTES.DEMO} element={<Demo />} />
            <Route path={ROUTES.LOGIN} element={<Login />} />
            <Route path={ROUTES.REGISTER} element={<Register />} />

            {/* Rotas protegidas */}
            <Route
                path={ROUTES.APP_PARENT}
                element={
                    <ProtectedRoute role="parent">
                        <ParentApp />
                    </ProtectedRoute>
                }
            />
            <Route
                path={ROUTES.APP_SCHOOL}
                element={
                    <ProtectedRoute role="school">
                        <SchoolDashboard />
                    </ProtectedRoute>
                }
            />

            {/* Fallback */}
            <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
        </Routes>
    );
}

function App() {
    return (
        <AuthProvider>
            <AppRoutes />
        </AuthProvider>
    );
}

export default App;
